export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14019.711693f5.jpg";